import { CommonModule } from '@angular/common';
import { Component, NgModule } from '@angular/core';
import { ColleaguesModule } from '@app/components/colleagues/colleagues.component';
import { MyCollaborationActivitiesModule } from '@app/components/my-collaboration-activities/my-collaboration-activities-widget/my-collaboration-activities-widget.component';
import { MyLatestSitesModule } from '@app/components/my-latest-sites/my-latest-sites.component';
import { SiteIndexModule } from '@app/components/site-index/site-index.component';
import { LinkModule } from '@app/directives/link.directive';

@Component({
  selector: 'cafcass-custom-collaboration',
  templateUrl: './custom-collaboration.component.html',
  styleUrls: ['./custom-collaboration.component.scss']
})
export class CustomCollaborationComponent { }
@NgModule({
  declarations: [CustomCollaborationComponent],
  exports: [CustomCollaborationComponent],
  imports: [
    CommonModule,
    LinkModule,
    MyCollaborationActivitiesModule,
    MyLatestSitesModule,
    ColleaguesModule,
    SiteIndexModule,
  ]
})
export class CustomCollaborationModule { }
